import RemoteApplicationIcon from './RemoteApplicationIcon';

export default RemoteApplicationIcon;
